// Roostr primitives — shared helpers ported from the web prototype
// (.agent/handoff-web/cards.jsx lines 4-17 and data.jsx PALETTES + fmtCZK).

// Solid warm-toned color pairs used as photo placeholders (data.jsx).
export const PALETTES: ReadonlyArray<readonly [string, string]> = [
  ['#E8D4C2', '#C89B7B'], // terracotta
  ['#EFD9C3', '#D4A574'], // sand
  ['#F5E6D3', '#C4A484'], // cream
  ['#D9C2B0', '#A8876C'], // taupe
  ['#E6CFB8', '#B8906F'], // honey
  ['#EADCCA', '#BE9472'], // wheat
  ['#D4BFA8', '#8F6F52'], // bark
  ['#F2DCC4', '#CD9B6D'], // apricot
  ['#E3C9AE', '#A37A55'], // toast
  ['#EEDBC5', '#B88C63'], // biscuit
]

// Stable gradient-fallback palette index per listing id (PhotoBlock/RealPhotos
// cycle the 10 PALETTES). One shared hash so every surface picks the same
// placeholder color for the same listing.
export function paletteFor(id: string): number {
  let h = 0
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0
  return Math.abs(h) % 10
}

export const pretty = (k: string): string => k.charAt(0).toUpperCase() + k.slice(1)

export const perM2 = (l: { price: number; area: number }): number =>
  Math.round(l.price / l.area)

export function fmtCZK(n: number): string {
  return new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 }).format(n) + ' Kč'
}

// Index median (upper median for even counts) — same semantics as the search
// page's insights strip (arr[floor(n/2)] over the sorted values), shared so
// the card PricePositionBar and the strip agree on where "median" sits.
export function medianOf(values: number[]): number {
  if (!values.length) return 0
  const sorted = [...values].sort((a, b) => a - b)
  return sorted[Math.floor(sorted.length / 2)]
}

// Listings carry no transaction_type field, so suffix decisions use a price
// heuristic: CZ monthly rents stay well under 500k; sale prices start ~1M.
// Used to suppress the '/mo' suffix on sale listings.
export function isLikelyMonthlyPrice(price: number): boolean {
  return price < 500_000
}

// Czech three-form pluralization: 1 → one, 2-4 → few, 0 and 5+ → many.
// English callers pass the same string for `few` and `many`.
export const czechPlural = (n: number, one: string, few: string, many: string): string =>
  n === 1 ? one : n >= 2 && n <= 4 ? few : many
